import { isUndefined } from 'lodash';
import Embed from './embed';

class InstagramEmbed extends Embed {
  static create(value) {
    if (!isUndefined(value.includeCaption)
      && !value.includeCaption
    ) {
      value.includeCaption = 'false'; // Convert to string to preserve data attribute
    }
    const domNode = super.create({
      ...value,
      label: 'instagram',
      customTitle: value.caption,
      iconName: '',
      iconClass: 'fa fa-instagram theme--light',
      buttons: ['edit'],
      denseMedia: true,
    });

    domNode.insertAdjacentHTML('beforeend', this.html(value));

    return domNode;
  }

  static value(domNode) {
    const data = domNode.dataset;
    console.debug('value data set', data);
    return {
      url: data.embedUrl,
      includeCaption: data.embedIncludeCaption,
    };
  }

  static html({
    url,
  }) {
    const previewUrl = url.endsWith('/') ? `${url}embed` : `${url}/embed`;
    const instagramEmbed = `<iframe width="320" height="440" src="${previewUrl}" frameborder="0"></iframe>`;
    return `
    <div class="ql-text-wrapper">
      ${instagramEmbed}
    </div>
    `;
  }
}

InstagramEmbed.blotName = 'instagramEmbed';
InstagramEmbed.className = 'ql-instagram';
InstagramEmbed.tagName = 'div';

export default InstagramEmbed;
